<template>
    
    <span class="cb cb--all">
        <input type="checkbox" 
            :checked="selected"
            @change="handleChange($event)" />
    </span>

</template>

<script>
import Vue from 'vue';

export const SELECT_ALL_EVENT = 'selectall'
export const SELECT_ALL_CHANGE_EVENT = 'selectallchange'

export const SelectAllBus = new Vue();

export default {

    data() {
        return {
            selected: false
        }
    },
    
    methods: {

        handleChange: function(event) {
            this.selected = event.target.checked
            this.fireChange()
        },

        fireChange: function() {
            this.$emit(SELECT_ALL_CHANGE_EVENT, this.selected)
            SelectAllBus.$emit(SELECT_ALL_CHANGE_EVENT, this.selected)
        }
    },

    created() {
        SelectAllBus.$on(SELECT_ALL_EVENT, isAllSelected => {
            this.selected = isAllSelected
        })
    }
}

</script>

<style scoped>

</style>